import React from 'react';
import PropTypes from 'prop-types';
import SchemaOrgJSONLD from './JSONLD';
import Base from './Base';
import OpenGraph from './OpenGraph';
import TwitterCard from './TwitterCard';

const Head = ({ title, description, keywords, url, image, social: { twitter } }) => {
  return <React.Fragment>
    <Base title={title} description={description} keywords={keywords}/>
    <SchemaOrgJSONLD url={url} title={title}/>
    <OpenGraph title={title} description={description} image={image} url={url}/>
    <TwitterCard image={image} description={description} domain={url} title={title} twitter={twitter}/>
  </React.Fragment>;
};

export default Head;

export const headMetadataFragment = graphql`
  fragment HeadMetadata on Site { 
      siteMetadata {
        title
        description
        keywords
        baseUrl
        logoUrl
        social {
          twitter
        }
      }
  }
`;


// WEBPACK FOOTER //
// ./src/components/Head/index.js